/** @jsx jsx */
import { jsx, Box, Flex, Grid } from "theme-ui";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { PageContentNonMemoized } from "gatsby-plugin-hfn-profile/components/PageContentNonMemoized";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import SlideToggle from "react-slide-toggle";
import { eventCallbackTriggers } from "../../templates/wppage";
import SRCMLogo from "../../../static/imgs/srcm-logo.png";
import Seo from "../../components/seo";
import Auth from "../../components/Auth";

const corpusFundPageContent = (id, modalTitle) => {
  const titletext = modalTitle || "Donation for Corpus Fund";
  return `<gatsby_donation donationId = "${id}" btntext = "${titletext}" btnBg = #4d8f15 colortext = black colorprimary = forestgreen colorsecondary = darkgreen colorbackground = white colormuted = #f6f6f6 colorhighlight = #efeffe titletext = "Donation for Corpus Fund" allowOverseas = false/>`;
};

const generalFundPageContent = (id, modalTitle) => {
  const titletext = modalTitle || "Heartfulness General Fund";
  return `<gatsby_donation donationId="${id}" btntext="${titletext}"
  btnBg=#4d8f15 colortext = navy colorprimary = #085788
  colorsecondary = midnightblue colorbackground = white
  colormuted = #f6f6f6 colorhighlight = #efeffe titletext =
  "Heartfulness General Fund" />`;
};

const PageContent = React.memo(PageContentNonMemoized);

const SrcmIndiaDonation = () => {
  const headerRef = useRef();

  const [applySticky, setApplySticky] = useState(false);

  const handleHeaderSticky = () => {
    if (headerRef.current && window.pageYOffset > headerRef.current.offsetTop)
      setApplySticky(true);
    else setApplySticky(false);
  };

  useEffect(
    () => window.addEventListener("scroll", handleHeaderSticky),
    [applySticky]
  );

  const eventCallback = useCallback(
    (event) => eventCallbackTriggers("Donation_for_srcm_india_donation", event),
    []
  );

  const navBarLinks = [
    { title: "Home", id: "index" },
    { title: "Meditation", id: "meditation" },
    { title: "Centres", id: "centres" },
    { title: "Activities", id: "activities" },
    { title: "About Us", id: "about-us" },
    { title: "Donate", className: "donate-btn" },
  ];

  const NavigateRouter = (item) => {
    let message = {
      title: item.title,
      url: `/${item.id}`,
    };
    if (item.id === "index") {
      message = {
        title: item.title,
        url: "/",
      };
      window.parent.postMessage(message, "*");
    }
    window.parent.postMessage(message, "*");
  };

  return (
    <>
      <Auth />
      <Box
        ref={headerRef}
        sx={
          applySticky
            ? {
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                background: "#fff",
                zIndex: 1000,
                boxShadow: "0 2px 6px rgb(0 0 0 / 5%)",
              }
            : {
                position: "static",
                boxShadow: "0 2px 6px rgb(0 0 0 / 5%)",
              }
        }
      >
        <SlideToggle
          collapsed="true"
          render={({ toggle, setCollapsibleElement }) => (
            <div className="header-collapsible">
              <div
                sx={{
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  boxShadow: "0px 0px 2px 1px #00000029",
                  logo: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    img: {
                      maxWidth: "300px",
                    },
                  },
                  nav: {
                    flexGrow: "2",
                    ul: {
                      display: "flex",
                      padding: 0,
                      justifyContent: "flex-end",
                      listStyle: "none",
                      li: {
                        a: {
                          paddingLeft: "14px",
                          paddingRight: "14px",
                          fontSize: "18px",
                          textDecoration: "none",
                          textTransform: "capitalize",
                        },
                      },

                      "@media screen and (max-width: 998px)": {
                        display: "none !important",
                      },
                    },
                    mobNavIcon: {
                      display: "none",
                      "@media screen and (max-width: 998px)": {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        position: "relative",
                        top: "14px",
                        fontSize: "23px",
                        color: "#bbbbbb",
                      },
                    },
                  },
                }}
              >
                <div
                  sx={{
                    width: "100%",
                    maxWidth: "1160px",
                    margin: "0 auto",
                    "@media only screen and (max-width: 767px)": {
                      width: "300px",
                    },
                    "@media only screen and (min-width: 480px) and (max-width: 767px)":
                      {
                        width: "420px",
                      },
                    "@media only screen and (min-width: 768px) and (max-width: 959px)":
                      {
                        width: "748px",
                      },
                    "@media only screen and (min-width: 960px) and (max-width: 1199px)":
                      {
                        width: "920px",
                      },
                    "@media only screen and (min-width: 1200px) and (max-width: 1400px)":
                      {
                        width: "1160px",
                      },
                  }}
                >
                  <div
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        img: {
                          maxWidth: "300px",
                        },
                      }}
                    >
                      <span to="/">
                        <img
                          src={SRCMLogo}
                          sx={{ width: applySticky ? "200px" : "250px" }}
                          alt=""
                        />
                      </span>
                    </div>
                    <nav>
                      <ul>
                        {navBarLinks.map((item) => {
                          if (item.id) {
                            return (
                              <li>
                                <span
                                  className={item.className || "menu-links"}
                                  onClick={() => NavigateRouter(item)}
                                  onKeyDown={() => NavigateRouter(item)}
                                  tabIndex={0}
                                  role="button"
                                  id={item.id}
                                  activeStyle={{
                                    color: "#179bb2",
                                  }}
                                  sx={{
                                    color: "#777777",
                                    ":hover": { color: "#179bb2" },
                                    padding: "0px 20px",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: "300",
                                  }}
                                >
                                  {item.title}
                                </span>
                              </li>
                            );
                          }
                          return (
                            <li>
                              <span
                                className={item.className || "menu-links"}
                                activeStyle={{
                                  color: "#179bb2",
                                }}
                                sx={{
                                  ...(!item.className && {
                                    color: "#777777",
                                    ":hover": { color: "#179bb2" },
                                    padding: "0px 20px",
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    fontWeight: "300",
                                  }),
                                  ...(item.className && {
                                    padding: " 8px 15px",
                                    borderRadius: "4px",
                                    backgroundColor: "#288bd0",
                                    color: "white",
                                    opacity: "0.6",
                                    pointerEvents: "none",
                                  }),
                                }}
                              >
                                {item.title}
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                      <div
                        sx={{
                          display: "none",
                          "@media screen and (max-width: 998px)": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            position: "relative",
                            top: "14px",
                            fontSize: "23px",
                            color: "#bbbbbb",
                          },
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faBars}
                          size="1x"
                          onClick={toggle}
                        />
                      </div>
                    </nav>
                  </div>
                </div>
              </div>

              <div
                sx={{
                  display: "none",
                  background: "#fcfcfc",
                  nav: {
                    ul: {
                      listStyle: "none",
                      margin: "16px 0 30px 0",
                      padding: "0",
                      li: {
                        a: {
                          fontSize: "13px",
                          display: "block",
                          borderBottom: "1px solid #f2f2f2",
                          padding: "12px 0 !important",
                          textDecoration: "none",
                          textTransform: "capitalize",
                        },
                      },
                    },
                  },
                  "@media screen and (max-width: 998px)": {
                    display: "block",
                  },
                }}
                ref={setCollapsibleElement}
              >
                <nav
                  sx={{
                    width: "100%",
                    maxWidth: "1160px",
                    margin: "0 auto",
                    "@media only screen and (max-width: 767px)": {
                      width: "300px",
                    },
                    "@media only screen and (min-width: 480px) and (max-width: 767px)":
                      {
                        width: "420px",
                      },
                    "@media only screen and (min-width: 768px) and (max-width: 959px)":
                      {
                        width: "748px",
                      },
                    "@media only screen and (min-width: 960px) and (max-width: 1199px)":
                      {
                        width: "920px",
                      },
                    "@media only screen and (min-width: 1200px) and (max-width: 1400px)":
                      {
                        width: "1160px",
                      },
                  }}
                >
                  <ul sx={{ listStyleType: "none", float: "right" }}>
                    {navBarLinks.map((item) => {
                      if (item.id) {
                        return (
                          <li
                            key={item.id}
                            sx={{
                              marginBottom: "10px",
                              borderBottom: "1px solid #f2f2f2",
                            }}
                          >
                            <span
                              onClick={() => NavigateRouter(item)}
                              onKeyDown={() => NavigateRouter(item)}
                              tabIndex={0}
                              role="button"
                              id={item.id}
                              activeStyle={{
                                color: "#179bb2",
                              }}
                              sx={{
                                color: "#777777",
                                ":hover": { color: "#179bb2" },
                                padding: "0px 20px",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "300",
                              }}
                            >
                              {item.title}
                            </span>
                          </li>
                        );
                      }
                      return (
                        <li>
                          <span
                            className={item.className || "menu-links"}
                            activeStyle={{
                              color: "#179bb2",
                            }}
                            sx={{
                              ...(!item.className && {
                                color: "#777777",
                                ":hover": { color: "#179bb2" },
                                padding: "0px 20px",
                                cursor: "pointer",
                                fontSize: "20px",
                                fontWeight: "300",
                              }),
                              ...(item.className && {
                                padding: " 8px 15px",
                                borderRadius: "4px",
                                backgroundColor: "#288bd0",
                                color: "white",
                                opacity: "0.6",
                                pointerEvents: "none",
                              }),
                            }}
                          >
                            {item.title}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </nav>
              </div>
            </div>
          )}
        />
      </Box>
      <Seo title="SRCM India Donations" />
      <div>
        <Grid
          sx={{
            fontWeight: "300",
          }}
        >
          <Box>
            <div
              sx={{
                padding: "35px 0px",
                backgroundColor: "#dff2f6",
                border: "1px solid #d3d5d2",
                marginBottom: "30px",
              }}
            >
              <div className="container">
                <h2
                  className="text-center"
                  sx={{
                    fontSize: "24px ",
                    fontWeight: "300",
                    color: "#43679c",
                  }}
                >
                  Welcome to SRCM India Donations
                </h2>
              </div>
            </div>
          </Box>
          <Box
            sx={{
              paddingRight: "35px",
              paddingLeft: "35px",
              fontSize: "17px ",
            }}
          >
            <Flex>
              <Box
                sx={{
                  flex: ["2", null, null, "2", null],
                  marginBottom: "35px",
                }}
              >
                <div sx={{ border: "1px solid rgb(153, 187, 232)" }}>
                  <p
                    sx={{
                      backgroundColor: "rgb(228, 237, 254)",
                      borderBottom: "1px solid rgb(153, 187, 232)",
                      color: "rgb(21, 66, 139)",
                      fontWeight: "600",
                      padding: "10px 20px",
                    }}
                  >
                    Please note
                  </p>
                  <p sx={{ padding: "0px 20px", lineHeight: "34px" }}>
                    At this time, due to government regulations,{" "}
                    <b>citizens of India only</b> can make online donations.
                    Others can contact{" "}
                    <a
                      href="mailto:info.accounts@srcm.org"
                      sx={{ color: "#4b77a1", textDecoration: "none" }}
                    >
                      info.accounts@srcm.org
                    </a>{" "}
                    for making donations.
                  </p>
                  <p sx={{ padding: "0px 20px", lineHeight: "34px" }}>
                    <b>There are no refunds for donations.</b>
                  </p>
                  <p sx={{ padding: "0px 20px", lineHeight: "34px" }}>
                    On completion of the donation, the filled donation form will
                    be generated and sent to you, which is to be printed,
                    signed, scanned and sent to{" "}
                    <a
                      href="mailto:info.accounts@srcm.org"
                      sx={{ color: "#4b77a1", textDecoration: "none" }}
                    >
                      info.accounts@srcm.org
                    </a>{" "}
                    or can be couriered to the address mentioned in the form. Or
                    you may fill and submit the form at your nearest center.
                  </p>
                </div>
              </Box>
            </Flex>

            <div
              sx={{
                color: "#31708f",
                backgroundColor: "#d9edf7",
                borderColor: "#bce8f1",
                padding: "15px 15px 2px 15px",
                marginBottom: "20px",
                border: "1px solid transparent",
                borderRadius: "4px",
              }}
            >
              <p>Please select a donation from the following list.</p>
            </div>

            <Box
              className="donation-container"
              sx={{
                border: "1px solid #ddd",
                marginBottom: "35px",
              }}
            >
              <Box
                sx={{
                  borderBottom: "1px solid #ddd",
                  padding: "8px",
                }}
              >
                <b>Donation for SRCM India - Corpus Fund</b>
                <br />
                <span>
                  Donation to Corpus Fund would form a part of the capital of
                  the Organization.
                </span>
                <div
                  className="donation-btn"
                  sx={{
                    display: "flex",
                  }}
                >
                  <PageContent
                    eventCallback={eventCallback}
                    pageContent={corpusFundPageContent(18, "Contribute Now")}
                  />
                </div>
              </Box>

              <Box
                sx={{
                  padding: "8px",
                }}
              >
                <b>Donation for SRCM India - General Fund</b>
                <br />
                <span>
                  Donation to General Fund would be used for the objectives of
                  the Organization and Heartfulness.
                </span>
                <div
                  sx={{
                    display: "flex",
                  }}
                >
                  <PageContent
                    eventCallback={eventCallback}
                    pageContent={generalFundPageContent(19, "Contribute Now")}
                  />
                </div>
              </Box>
            </Box>
          </Box>
        </Grid>
      </div>
      <div
        sx={{
          padding: "0px",
          background: "#e8f2f9",
          height: "73px",
          bottom: "0",
          width: "100%",
        }}
      >
        <div
          sx={{
            padding: "10px 0px",
            background: "#e8f2f9",
          }}
        >
          <div
            sx={{
              marginTop: "19px",
              color: "#43679c",
              fontSize: "16px",
            }}
          >
            <p
              sx={{
                lineHeight: "24px",
                fontSize: "16px",
                fontWeight: "300",
                textAlign: "center",
              }}
            >
              {" "}
              © Copyright 2023 Shri Ram Chandra Mission, All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SrcmIndiaDonation;
